
    export const LISTITEMS: any[] = [
        {"url":"/dashboard/dashboard1", "name":"Dashboard 1", "icon":"ft-home"},
        {"url":"/dashboard/dashboard2", "name":"Dashboard 2", "icon":"ft-home"},       
        {"url":"/danhmuc/loaidanhmuc", "name":"Loại danh mục", "icon":"ft-grid"},   
    ]

